import { Injectable } from '@angular/core';
import { FormBuilderControl, ILookupSelectItem } from '../../common/formbuilder/FormBuilderControl';

export interface IContalLookupCache {
  endpointUrl: any;
  dbField: any;
  lookups: Array<ILookupSelectItem>
}


@Injectable({
  providedIn: 'root'
})
export class ControlLookupCacheService {
  private cachedLookups: Array<IContalLookupCache> = new Array<IContalLookupCache>();

  public getCachedLookups(endpointUrl: any, formField: FormBuilderControl): boolean {
    if (!formField) return false;
    const exist = this.cachedLookups.filter(o => o.endpointUrl == endpointUrl && o.dbField == formField.field);
    if (exist.length == 0)
      return false;
    // ensure lookups array exists before assigning
    formField.lookups = exist[0].lookups || [];
    return true;
  }

  public setCachedLookups(endpointUrl: any, formField: FormBuilderControl) {
    if (!formField) return;

    // clone defensively - handle undefined lookups
    const lookupsClone = (formField.lookups && Array.isArray(formField.lookups)) ? formField.lookups.slice() : [];

    try {
      const existing = this.cachedLookups.find(o => o.dbField == formField.field && o.endpointUrl == endpointUrl);
      if (existing) {
        // defensively assign
        existing.lookups = lookupsClone;
      } else {
        this.cachedLookups.push({ dbField: formField.field, endpointUrl: endpointUrl, lookups: lookupsClone });
      }
    } catch (err) {
      // safe fallback - log to console for diagnostics without throwing
      console.error('ControlLookupCacheService.setCachedLookups failed', { endpointUrl, field: formField?.field, err });
    }
  }

  public clearCachedLookups(formField: FormBuilderControl) {
    if (!formField) return;
    // remove all cached entries matching the field
    this.cachedLookups = this.cachedLookups.filter(o => o.dbField != formField.field);
  }

  public clear() {
    this.cachedLookups = new Array<IContalLookupCache>();
  }
}
